function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "31",
  height: "30",
  viewBox: "0 0 31 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.963 9.264l13.886-4.63a1 1 0 01.632 0L29.39 9.272c.912.304.912 1.593 0 1.897l-6.269 2.09v8.55a1 1 0 01-.576.906l-.108.043-6.955 2.32a1 1 0 01-.508.032l-.125-.033-6.952-2.32a1 1 0 01-.677-.832l-.007-.116v-8.55l-4.955-1.651v6.463a1 1 0 01-1.993.116l-.007-.116v-7.85a1 1 0 01.617-.925m20.905 2.3l.05-.016 4.08-1.36-10.744-3.581L4.42 10.219l4.062 1.354c.031.009.062.02.093.031l6.59 2.197 6.614-2.205zm-6.93 4.21l-5.637-1.88v7.162l5.953 1.985 5.955-1.985v-7.162l-5.639 1.88a1 1 0 01-.632 0z",
  fill: "currentColor"
})));